import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Experience, Imagesizes } from '../../models/BackendModels';

/**
 * Abstract service for handling data operations in the application.
 * This is the base interface that all concrete data services (backend, dummy, etc.) must implement.
 */
@Injectable({
	providedIn: 'root',
})
export abstract class PublicDataService {
	abstract GetExperienceByUuid(uuid: string): Observable<Experience>;

	abstract GetURLAsObject(
		id: number,
		articleType: 'image' | 'audio' | 'video' | 'pdf' | 'doc',
	): Observable<string | undefined>;

	/**
	 * Set a dynamic getter function for runtime object URL resolution
	 * @param getter Function that takes a fileId and returns an Observable of URL string or undefined
	 */
	abstract setDynamicGetter(
		getter: (
			fileId: number,
			size: Imagesizes,
		) => Observable<string | undefined>,
	): void;

	/**
	 * Remove the dynamic getter
	 */
	abstract clearDynamicGetter(): void;

	// Dynamic getter function for runtime object URL resolution
	abstract dynamicGetter?: (
		fileId: number,
		size: Imagesizes,
	) => Observable<string | undefined>;

	abstract SetDefaultShareUuid(uuid: string): void;
	abstract GetDefaultShareUuid(): string;
}
